export default "__VITE_ASSET__0f62c245__"